<template>
  <div class="slide" v-on:mouseover="stop()" v-on:mouseout="move()">
    <div class="slideshow">
      <transition-group tag="ul" name="image">
        <!-- <li v-for="(item, index) in imgArray" v-show="index===mark" :key="index">
          <a href="#">
            <img :src='item.img'>
          </a>
        </li> -->
        <li v-for="(item, index) in imgArray" v-show="index===mark" :key="index+1">
          <a target="_blank" :href="item.href">
            <img v-if="index == 0" src='../../images/BRPC.jpg'>
            <img v-else-if="index == 1" src='../../images/DORIS.jpg'>
            <img v-else src='../../images/EChars.jpg'>
          </a>
        </li>
      </transition-group>
    </div>
    <div class="bullet">
      <span v-for="(item, index) in imgArray" :class="{ 'active':index===mark }"
      @click="change(index)" :key="index"></span>
    </div>
  </div>
</template>
 
<script>
export default {
  props: ["imgArray"],
  data () {
    return {
      timer: null, //定时器
      mark: 0 //比对图片索引的变量
    }
  },
  methods: {
    autoPlay () {
      this.mark++;
      if (this.mark === 3) {
        this.mark = 0
      }
    },
    play () {
      this.timer = setInterval(this.autoPlay, 4000)
    },
    change (i) {
      this.mark = i
    },
    stop () {
      clearInterval(this.timer)
    },
    move () {
      this.timer = setInterval(this.autoPlay, 4000)
    }
  },
  created () {
    this.play()
  }
}
</script>

<style lang="less" scoped>
  .slide {
    max-width: 100%;
    height: auto;
    margin: 0 auto;
    background-color: #030309;
    overflow: hidden;
    position: relative;
  }
  .slideshow {
    width: 100%;
    height: 320px;
    text-align: center;
    ul{
      width: 100%;
      height: 100%;
    }
  }
  li {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  img {
    height: 320px;
  }
  .bar {
    position: absolute;
    width: 100%;
    bottom: 10px;
    margin: 0 auto;
    z-index: 10;
    text-align: center;
  }
  .bar span {
    width: 20px;
    height: 5px;
    border: 1px solid;
    background: white;
    display: inline-block;
    margin-right: 10px;
  }
  .active {
    background: #fff !important;
  }

  .bullet{
    height: 30px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    span{
        width: 70px;
        height: 5px;
        border: .5px solid #eee;
        display: inline-block;
        margin: 0 10px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/common/head-swiper/index.vue